import { rest } from 'utils';

export default {
  getAll: () => rest.get({ url: 'locations?depth=4' }),
  get: ({ regionId }) => rest.get({ url: `locations/${regionId}` }),
  getLocations: ({ regionId, locationId }) => rest.get({ url: `locations/${regionId}/${locationId}` }),
};
